'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreSwitcherPopup = function () {
  function StoreSwitcherPopup(el) {
    (0, _classCallCheck3.default)(this, StoreSwitcherPopup);

    this.classes = {
      buttons: 'js-StoreSwitcherPopup_Button'
    };

    this.els = {
      el: el,
      close: (0, _functional.getElements)('.' + this.classes.close),
      buttons: (0, _functional.getElements)('.' + this.classes.buttons)
    };

    this.showStoreSwitcherPopup = this.showStoreSwitcherPopup.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);

    this.setupListeners();

    this.setupModal();
  }

  (0, _createClass3.default)(StoreSwitcherPopup, [{
    key: 'setupModal',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var theCountryCode;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getCountryCode();

              case 2:
                theCountryCode = _context.sent;

                this.setupCountrySwitcherModal(theCountryCode);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setupModal() {
        return _ref.apply(this, arguments);
      }

      return setupModal;
    }()
  }, {
    key: 'getCountryCode',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var browsingContext;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch('/browsing_context_suggestions.json').then(function (response) {
                  if (!response.ok) {
                    throw response;
                  }
                  return response.json();
                });

              case 2:
                browsingContext = _context2.sent;
                return _context2.abrupt('return', browsingContext.detected_values.country.handle.toLowerCase());

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCountryCode() {
        return _ref2.apply(this, arguments);
      }

      return getCountryCode;
    }()
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      this.setupCountrySwitcherModal = this.setupCountrySwitcherModal.bind(this);
      this.findCountryConfigByCountryCode = this.findCountryConfigByCountryCode.bind(this);

      this.els.buttons.forEach(function (button) {
        button.addEventListener('click', _this.onButtonClick);
      });
    }
  }, {
    key: 'showStoreSwitcherPopup',
    value: function showStoreSwitcherPopup() {
      this.els.el.classList.add('mod-Modal-active');
    }
  }, {
    key: 'updateButtons',
    value: function updateButtons(store) {
      var storeButton = this.els.buttons.filter(function (button) {
        return button.dataset.store === store;
      }).map(function (button) {
        return button;
      }).shift();

      storeButton.setAttribute('aria-hidden', 'false');
    }
  }, {
    key: 'onButtonClick',
    value: function onButtonClick(e) {
      var selectedStore = e.target.dataset.stayButtonStoreInitial;
      if (selectedStore) {
        _jsCookie2.default.set(this.cookieName, selectedStore, { expires: 90 });
      }

      this.els.el.classList.remove('mod-Modal-active');
    }
  }, {
    key: 'setupCountrySwitcherModal',
    value: function setupCountrySwitcherModal(countryCode) {
      var _findCountryConfigByC = this.findCountryConfigByCountryCode(countryCode),
          storeName = _findCountryConfigByC.storeName;

      var rowStoreUrl = window.location.href.indexOf('https://www.champohaircare.com') !== -1;
      var usaStoreUrl = window.location.href.indexOf('https://us.champohaircare.com') !== -1;

      this.updateButtons(storeName);

      // If user's location matches the current store
      if (storeName === this.currentStoreCountry) {
        return;
      }

      // If user's location doesn't match the current store, but user has opted to stay in the current store previously
      if (_jsCookie2.default.get(this.cookieName) === this.currentStoreCountry) {
        return;
      }

      if (
      // US customers not on US stores
      countryCode === 'us' && !usaStoreUrl ||
      // None US customers on US store
      countryCode !== 'us' && usaStoreUrl ||
      // UK customers on UK store not on GBP currency
      countryCode === 'gb' && rowStoreUrl && window.theme.currency !== 'GBP' ||
      // European customers on UK store not on EURO currency
      countryCode !== 'us' && countryCode !== 'gb' && rowStoreUrl && window.theme.currency !== 'EUR' ||
      // Australian customers on UK store not on AUD currency
      countryCode === 'au' && rowStoreUrl && window.theme.currency !== 'AUD' ||
      // Canadian customers on UK store not on CAD currency
      countryCode === 'ca' && rowStoreUrl && window.theme.currency !== 'CAD') {
        this.showStoreSwitcherPopup();
      }
    }
  }, {
    key: 'findCountryConfigByCountryCode',
    value: function findCountryConfigByCountryCode(countryCode) {
      var countryConfig = Object.entries(this.storeConfigs).filter(function (_ref3) {
        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
            storeConfig = _ref4[1];

        return (typeof storeConfig === 'undefined' ? 'undefined' : (0, _typeof3.default)(storeConfig)) === 'object';
      }).filter(function (_ref5) {
        var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
            storeConfig = _ref6[1];

        return 'countryList' in storeConfig;
      }).filter(function (_ref7) {
        var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
            storeConfig = _ref8[1];

        return storeConfig.countryList.map(function (c) {
          return c.toLowerCase();
        }).includes(countryCode);
      });

      if (countryConfig.length > 0) {
        var _countryConfig$ = (0, _slicedToArray3.default)(countryConfig[0], 2),
            storeName = _countryConfig$[0],
            storeConfig = _countryConfig$[1];

        return { storeName: storeName, storeConfig: storeConfig };
      }

      return {
        storeName: this.storeConfigs.fallbackStore,
        storeConfig: this.storeConfigs[this.storeConfigs.fallbackStore]
      };
    }
  }, {
    key: 'cookieName',
    get: function get() {
      return 'BAO-selected-store';
    }
  }, {
    key: 'currentCountryCode',
    get: function get() {
      switch (this.currentStoreCountry) {
        case 'us':
          return 'us';
        case 'eu':
          return 'eu';
        case 'au':
          return 'au';
        case 'ca':
          return 'ca';
        default:
          return 'gb';
      }
    }
  }, {
    key: 'currency',
    get: function get() {
      return _jsCookie2.default.get('cart_currency');
    }
  }, {
    key: 'currentStoreCountry',
    get: function get() {
      return this.els.el.dataset.storeSwitcherPopupCurrentStore;
    }
  }, {
    key: 'storeConfigs',
    get: function get() {
      return {
        fallbackStore: this.els.el.dataset.storeSwitcherPopupFallbackStore,
        gb: {
          name: this.els.el.dataset.storeSwitcherPopupUkName,
          url: this.els.el.dataset.storeSwitcherPopupUkUrl,
          countryList: this.els.el.dataset.storeSwitcherPopupUkCountryList.split(','),
          flag: this.els.el.dataset.storeSwitcherPopupUkFlag
        },
        eu: {
          name: this.els.el.dataset.storeSwitcherPopupEuName,
          url: this.els.el.dataset.storeSwitcherPopupEuUrl,
          countryList: this.els.el.dataset.storeSwitcherPopupEuCountryList.split(','),
          flag: this.els.el.dataset.storeSwitcherPopupEuFlag
        },
        us: {
          name: this.els.el.dataset.storeSwitcherPopupUsName,
          url: this.els.el.dataset.storeSwitcherPopupUsUrl,
          countryList: this.els.el.dataset.storeSwitcherPopupUsCountryList.split(','),
          flag: this.els.el.dataset.storeSwitcherPopupUsFlag
        },
        au: {
          name: this.els.el.dataset.storeSwitcherPopupAuName,
          url: this.els.el.dataset.storeSwitcherPopupAuUrl,
          countryList: this.els.el.dataset.storeSwitcherPopupAuCountryList.split(','),
          flag: this.els.el.dataset.storeSwitcherPopupAuFlag
        },
        ca: {
          name: this.els.el.dataset.storeSwitcherPopupCaName,
          url: this.els.el.dataset.storeSwitcherPopupCaUrl,
          countryList: this.els.el.dataset.storeSwitcherPopupCaCountryList.split(','),
          flag: this.els.el.dataset.storeSwitcherPopupCaFlag
        }
      };
    }
  }, {
    key: 'currentQueryString',
    get: function get() {
      return _queryString2.default.parse(window.location.search);
    }
  }, {
    key: 'parsedQuerystring',
    get: function get() {
      return Object.assign({}, this.currentQueryString);
    }
  }]);
  return StoreSwitcherPopup;
}(); /* eslint-disable no-console */

exports.default = StoreSwitcherPopup;